/* TDS pill nav: white concept logo, solid background once the page scrolls. */
(function () {
  var logo = document.querySelector('.section-header .header__logo img');
  var src = document.documentElement.getAttribute('data-tds-logo');
  if (logo && src) { logo.src = src; logo.removeAttribute('srcset'); logo.removeAttribute('sizes'); }
  var root = document.documentElement, on = false;
  var check = function () { var s = (window.scrollY || 0) > 80; if (s !== on) { on = s; root.classList.toggle('tds-nav-solid', s); } };
  window.addEventListener('scroll', check, { passive: true }); check();
})();
